module.exports = __webpack_public_path__ + "img/marker-east.bcdcacf6.svg";